import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { Box, Skeleton, Stack, Tooltip, useTheme } from "@vapor/react-material";
import React from "react";

interface SectionInterface {
    key: string;
    label: string;
    hidden?: boolean;
    disabled?: boolean;
    tooltip?: React.ReactNode | string;
}

interface ISidebarItem {
    active?: boolean;
    children?: any;
    disabled?: boolean;
    onChange?: () => void;
    tooltip?: any;
}

const SidebarItem = ({ active, children, disabled, onChange, tooltip }: ISidebarItem) => {
    const {
        palette: {
            primary: {
                interactiveSelectedColor: Azure,
                textDefaultColor: YankeesBlue,
                interactiveDefault: RichElectricBlue,
                textDisabledColor: QuickSilver
            }
        }
    } = useTheme();

    const activeStyle = {
        paddingLeft: "40px",
        borderLeft: `5px solid ${RichElectricBlue}`,
        color: RichElectricBlue,
        background: Azure,
        fontWeight: 500
    };

    const disabledStyle = {
        color: QuickSilver,
        fontWeight: "normal"
    };

    const itemRet = (
        <Box
            onClick={disabled ? () => {} : () => onChange?.()}
            sx={{
                padding: "4px 0 4px 45px",
                cursor: "pointer",
                boxSizing: "border-box",
                height: "32px",
                ...(disabled
                    ? disabledStyle
                    : active
                    ? activeStyle
                    : {
                          border: `1px solid transparent`,
                          "&:hover": {
                              border: `1px solid ${RichElectricBlue}`
                          }
                      })
            }}
        >
            <ExtendedTypography color={disabled ? QuickSilver : active ? RichElectricBlue : YankeesBlue} variant="body">
                {children}
            </ExtendedTypography>
        </Box>
    );
    if (tooltip) {
        return (
            <Tooltip arrow placement="bottom" title={tooltip}>
                <div>{itemRet}</div>
            </Tooltip>
        );
    }
    return <>{itemRet}</>;
};

interface ISidebarMenu {
    sections: Array<SectionInterface>;
    activeSection?: string;
    loading?: boolean;
    onChange?: (val: any) => void;
}

const SidebarMenu = ({ sections, activeSection, onChange, loading }: ISidebarMenu) => {
    return (
        <Stack direction={"column"}>
            {sections?.map((it: SectionInterface) => {
                if (it.hidden) {
                    return null;
                }
                return (
                    <>
                        {loading ? (
                            <Box mb={1}>
                                <Skeleton width={300} height={28} sx={{ transform: "scale(1)" }} />
                            </Box>
                        ) : (
                            <SidebarItem
                                disabled={it?.disabled}
                                tooltip={it?.tooltip}
                                key={it?.key}
                                onChange={() => onChange?.(it?.key)}
                                active={it?.key === activeSection}
                            >
                                {it.label}
                            </SidebarItem>
                        )}
                    </>
                );
            })}
        </Stack>
    );
};

export default SidebarMenu;
